import { useEffect, useMemo, useRef, useState } from "react";

export function usePagedRows(rows, pageSize) {
  const [page, setPage] = useState(0);
  const allRows = rows || [];
  const totalPages = Math.max(1, Math.ceil(allRows.length / pageSize) || 1);
  const prevLengthRef = useRef(allRows.length);

  useEffect(() => {
    const prev = prevLengthRef.current;
    const next = allRows.length;
    const maxPage = Math.max(0, Math.ceil(next / pageSize) - 1);

    setPage((current) => {
      if (next > prev) return maxPage;
      if (current > maxPage) return maxPage;
      return current;
    });

    prevLengthRef.current = next;
  }, [allRows.length, pageSize]);

  const pagedRows = useMemo(() => {
    const start = page * pageSize;
    return allRows.slice(start, start + pageSize);
  }, [allRows, page, pageSize]);

  return {
    pagedRows,
    page,
    totalPages,
    totalItems: allRows.length,
    pageSize,
    canPrev: page > 0,
    canNext: page < totalPages - 1,
    goPrev: () => setPage((p) => Math.max(0, p - 1)),
    goNext: () => setPage((p) => Math.min(totalPages - 1, p + 1)),
    setPage,
  };
}
